import api from '../../../configs/api';
import {
  getStorage,
  removeStorage,
} from '../../../utils/functions/localstorage';
import { ME_GET, ME_RESET } from '../types';

export const meGet = () => async (dispatch) => {
  const rememeber = JSON.parse(getStorage('remember'));
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_API_URL}/user/${rememeber.uid.id}`,
    );
    dispatch({
      type: ME_GET,
      payload: data,
    });
  } catch (error) {
    console.error(error);
    await removeStorage('token');
    await removeStorage('remember');
    alert('โทเค็นหมดอายุ');
    // window.location.reload();
    dispatch({ type: ME_RESET });
    throw new Error(error);
  }
};

export const meReset = () => async (dispatch) => {
  dispatch({ type: ME_RESET, payload: null });
};
